module.exports = __webpack_public_path__ + "img/g-play.b2c0e33a.png";